import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fileInput'];

  submitForm() {
    this.fileInputTarget.closest('form')?.submit();
  }
}
